var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 11.3612C17.7562 10.1097 18.3327 9 18.3327 9C18.3327 9 15.3023 3.16667 9.99935 3.16667C9.71501 3.16667 9.43718 3.18344 9.16601 3.21518C8.88085 3.24857 8.60301 3.29852 8.33268 3.36293M9.99935 6.5C10.2915 6.5 10.572 6.55012 10.8327 6.64226C11.543 6.89332 12.106 7.45633 12.3571 8.16667C12.4492 8.42733 12.4993 8.70783 12.4993 9M2.49935 1.5L17.4993 16.5M9.99935 11.5C9.70718 11.5 9.42668 11.4498 9.16601 11.3577C8.45568 11.1067 7.89266 10.5437 7.6416 9.83333C7.59423 9.69933 7.55796 9.56008 7.53391 9.41667M3.45519 6.5C3.19832 6.78709 2.96797 7.06867 2.76488 7.33333C2.0434 8.2735 1.66602 9 1.66602 9C1.66602 9 4.69632 14.8333 9.99935 14.8333C10.2837 14.8333 10.5615 14.8166 10.8327 14.7848",
    stroke: "#A3AED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eyeClose.59d34aa68286b1dcaf7750660b3ce6e4.svg";
export { ForwardRef as ReactComponent };